import { render, staticRenderFns } from "./TestVideoOwerviewPageView.vue?vue&type=template&id=5a67e132&scoped=true&"
import script from "./TestVideoOwerviewPageView.vue?vue&type=script&lang=js&"
export * from "./TestVideoOwerviewPageView.vue?vue&type=script&lang=js&"
import style0 from "./TestVideoOwerviewPageView.vue?vue&type=style&index=0&id=5a67e132&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67e132",
  null
  
)

export default component.exports